import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class LangTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Spracheinstellungen" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Sprache: Deutsch', descriptionColumn: 'Darstellung der Benutzeroberfläche in deutscher Sprache' },
        { actionColumn: 'Sprache: English', descriptionColumn: 'Darstellung der Benutzeroberfläche in Englisch' },
        { actionColumn: 'Sprache: Français', descriptionColumn: 'Darstellung der Benutzeroberfläche in Französisch' },
        { actionColumn: 'Sprache: Zhōngwén', descriptionColumn: 'Darstellung der Benutzeroberfläche in Chinesisch' },
        { actionColumn: 'Sprache: Polski', descriptionColumn: 'Darstellung der Benutzeroberfläche in Polnisch' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

LangTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(LangTable)